import { iconImageIdentifierAttribute } from '../constants/hsicon';
export const nodeIsIconElement = (editor, node) => editor.dom.is(node, `img[${iconImageIdentifierAttribute}]`);
export function iconIsOnlyChild(editor, element) {
  if (!element) return false;
  if (nodeIsIconElement(editor, element)) return true;
  const childNodes = Array.from(element.childNodes).filter(childNode => {
    if (childNode.nodeType === 3 && childNode.textContent && childNode.textContent.trim() === '') {
      return false;
    }
    return true;
  });
  if (childNodes.length === 1) {
    return iconIsOnlyChild(editor, childNodes[0]);
  }
  return false;
}